import { createRoot } from 'react-dom/client';
import { applicaTemaSalvato } from '@/features/theme/useTheme';
import { ingresso } from '@/lib/ingresso';
import './index.css';

// Prima del primo disegno, non dentro un componente: il primo effetto di React gira dopo il primo
// rendering, e per quel fotogramma un utente in tema scuro vedrebbe un lampo bianco a schermo intero.
applicaTemaSalvato();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Elemento #root non trovato in index.html');
}
const root = createRoot(container);

// Il sito pubblico o il portale (decisione 0008, `lib/ingresso.ts`). Due import dinamici, cosi'
// ognuno e' un bundle a se': il visitatore del sito non scarica il portale, e viceversa.
const chiavi = Object.keys(window.sessionStorage);
if (ingresso(window.location.pathname, window.location.search, chiavi) === 'portale') {
  void import('@/portale').then(({ montaPortale }) => montaPortale(root));
} else {
  void import('@/site/SitoPubblico').then(({ montaSito }) => montaSito(root));
}
